import { create } from "zustand"

import { FlagType } from "../../../types"

interface DoterChatStore {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void

  tab: FlagType
  setTab: (tab: FlagType) => void
}

export const useDoterChatStore = create<DoterChatStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),

  tab: FlagType.RED,
  setTab: (tab) => set({ tab }),
}))
